module.exports = __webpack_public_path__ + "static/img/no-data.91afbeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/no-data.png
// module id = eW+r
// module chunks = 1